import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import moment from "moment";
// import _ from "lodash"

import DashboardLayout from "./layouts/DashboardLayout";
import CheckinLayout from "./layouts/CheckinLayout";
import MainLayout from "./layouts/MainLayout";
import DigitalVIRLayout from "./layouts/DigitalVIRLayout";
import RentalManageLayout from "./layouts/RentalManageLayout";

import DashboardView from "./views/dashboard";
import RentalHistory from "./views/rental/RentalHistory";
import LoginView from "./views/auth/LoginView";
import CheckinView from "./views/auth/CheckInView";
import GenericCheckinView from "./views/auth/GenericCheckinView";
import RentalPhotos from "./views/rental/RentalPhotos";
import UploadRentalPhoto from "./views/rental/UploadRentalPhoto";
import RentalAgreement from "./views/rental/RentalAgreement";
import TaxInvoice from "./views/rental/TaxInvoice";
import TollsInvoice from "./views/rental/TollsInvoice";
import DamageDocumentation from "./views/rental/DamageDocumentation";
import VehicleIncideReports from "./views/rental/VehicleIncideReports";

import PersonalInfoForm from "./components/PersonalInfoForm";
import CheckinApp from "./views/checkin/App";
import AdditionalDriverCheckinForm from "./views/checkin/AdditionalDriver";
import CheckinVerify from "./views/checkin/CheckinVerify";
import CheckinComplete from "./views/checkin/CheckinComplete";
import CheckinSteps from "./views/checkin/CheckinSteps";
import CheckinPrivacy from "./views/checkin/CheckinPrivacy";
import CheckinSummary from "./views/checkin/CheckinSummary";

import DigitalVIRLandingPage from "./views/digitalVIR/LandingPage";
import DigitalVIRLogin from "./views/digitalVIR/Login";
import DigitalVIRExistingdamagePage from "./views/digitalVIR/ExistingDamagePage";
import DigitalVIRIncidentSelection from "./views/digitalVIR/IncidentSelection";
import DigitalVIRVehicleConditionAndPolice from "./views/digitalVIR/VehicleConditionAndPolice";
import DigitalVIRIncidentDetails from "./views/digitalVIR/IncidentDetails";
import DigitalVIROtherDriverDetails from "./views/digitalVIR/OtherDriverDetails";
import DigitalVIRThirdPartyDetails from "./views/digitalVIR/ThirdPartyDetails";
import DigitalVIRWitnessDetails from "./views/digitalVIR/WitnessDetails";
import DigitalVIRDamageDetails from "./views/digitalVIR/DamageDetails";
import DigitalVIRReviewPage from "./views/digitalVIR/ReviewPage";
import DigitalVIRSubmissionPage from "./views/digitalVIR/SubmissionPage";
import DiveCompletePage from "./views/digitalVIR/DiveCompletePage";

import RentalManageLogin from "./views/rentalManage/RentalManageLogin";

import NotFoundView from "./views/defaults/NotFoundView";
import DefaultView from "./views/defaults/DefaultPath";
import getDemoFromUrl from "./utils/getDemoFromUrl";
import getBrandFromUrl from "./utils/getBrandFromUrl";

import * as authActions from "./actions/authActions";
import * as checkinActions from "./actions/checkinActions";
import * as appActions from "./actions/appActions";
import { enableDemo } from "./env";
import { athenaAuth } from "./sagas/virSaga";
import ContactUs from "./views/digitalVIR/ContactUs";
import Expire from "./views/digitalVIR/Expire";
import RentalExpiredPage from "./views/digitalVIR/RentalExpiredPage";
import SmsPage from "./views/digitalVIR/SmsPage";
import EVInvoice from "./views/rental/EVInvoice";
import InfringementsInvoice from "./views/rental/InfringementsInvoice";
import RentalManageBooking from "./views/rentalManage/RentalManageBooking";
import RentalDateChangingComfirm from "./views/rentalManage/RentalDateChangingComfirm";

const PrivateRoute = ({ component: Component, ...props }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => ({ ...state.auth }));

  useEffect(() => {
    if (auth.expires <= moment().format()) {
      dispatch(authActions.logout());
      dispatch(
        appActions.createToast({
          type: "error",
          message: "Your session has expired. Please login again to continue.",
        })
      );
    }
  });

  if (auth.success) {
    return <Component {...props} />;
  } else {
    return <Navigate to="/login" />;
  }
};

const CheckinRoute = ({ component: Component, ...props }) => {
  const dispatch = useDispatch();
  const checkin = useSelector((state) => ({ ...state.checkin }));
  const isDemo = useSelector((state) => state.checkin.isDemo);
  const isAdditionalDriver = useSelector((state) => state.checkin.isAdditionalDriver);
  const isGeneric = useSelector((state) => state.checkin.isGenericCheckin);

  useEffect(() => {
    if (checkin.auth.expires <= moment().format()) {
      // dispatch(checkinActions.setIsGenericCheckin({ isGenericCheckin: brand == "Generic" }));

      dispatch(checkinActions.checkout());
      //   console.log('checkin.auth.expires, CheckinRoute', checkin.auth.expires )

      //   dispatch(
      //     appActions.createToast({
      //       type: "error",
      //       message: "Your session has expired. Please login again to continue.",
      //     })
      //   );
    }
  });

  if (checkin.auth.success) {
    return <Component {...props} />;
  } else if (isDemo) {
    return <Navigate to="/checkin-demo/login" />;
  } else if (isAdditionalDriver) {
    return <Navigate to="/additional-driver-checkin/login" />;
  } else if (isGeneric) {
    return <Navigate to="/generic-checkin/login" />;
  } else {
    return <Navigate to="/checkin/login" />;
  }
};

const DigitalVIRGuardRoute = ({ component: Component, ...props }) => {
  const digitalVIR = useSelector((state) => state.vir);
  const brand = getBrandFromUrl().toLocaleUpperCase();
  if (digitalVIR.athenaAuth.authorization) {
    return <Component {...props} />;
  } else {
    return <Navigate to={`/vehicleincidents/landing-page?brand=${brand}`} />;
  }
};

const routes = [
  {
    path: "app",
    element: <PrivateRoute component={DashboardLayout} />,
    children: [
      { path: "rental-photos", element: <PrivateRoute component={RentalPhotos} /> },
      { path: "upload-vehicle-photos", element: <PrivateRoute component={UploadRentalPhoto} /> },
      { path: "rental-agreement", element: <PrivateRoute component={RentalAgreement} /> },
      { path: "tax-invoice", element: <PrivateRoute component={TaxInvoice} /> },
      { path: "tolls-invoice", element: <PrivateRoute component={TollsInvoice} /> },
      { path: "ev-invoice", element: <PrivateRoute component={EVInvoice} /> },
      { path: "infringement-invoice", element: <PrivateRoute component={InfringementsInvoice} /> },
      { path: "damage-documentation", element: <PrivateRoute component={DamageDocumentation} /> },
      {
        path: "vehicle-incident-reports",
        element: <PrivateRoute component={VehicleIncideReports} />,
      },
      { path: "fleet-guide", element: <PrivateRoute component={DashboardView} /> },
      { path: "terms", element: <PrivateRoute component={DashboardView} /> },
      { path: "rentalhistory", element: <PrivateRoute component={RentalHistory} /> },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
  {
    path: "generic-checkin",
    element: <CheckinRoute component={CheckinLayout} />,
    children: [{ path: "*", element: <Navigate to="/404" /> }],
  },
  {
    path: "additional-driver-checkin",
    element: <CheckinRoute component={CheckinLayout} />,
    children: [
      { path: "verify", element: <CheckinRoute component={CheckinVerify} /> },
      { path: "checkin-form", element: <CheckinRoute component={AdditionalDriverCheckinForm} /> },
      { path: "checkin-summary", element: <CheckinRoute component={CheckinSummary} /> },
      { path: "complete", element: <CheckinRoute component={CheckinComplete} /> },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },

  {
    path: "checkin",
    element: <CheckinRoute component={CheckinLayout} />,
    children: [
      { path: "verify", element: <CheckinRoute component={CheckinVerify} /> },
      { path: "checkin-form", element: <CheckinRoute component={CheckinApp} /> },
      { path: "checkin-summary", element: <CheckinRoute component={CheckinSummary} /> },
      { path: "complete", element: <CheckinRoute component={CheckinComplete} /> },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },

  {
    path: "vehicleincidents",
    element: <DigitalVIRLayout />,
    children: [
      { index: true, element: <Navigate replace to={"landing-page"} /> },
      { path: "landing-page", element: <DigitalVIRLandingPage /> },
    ],
  },
  {
    path: "vehicleincidents",
    element: <DigitalVIRGuardRoute component={DigitalVIRLayout} />,
    children: [
      { path: "vir-login", element: <DigitalVIRLogin /> },
      { path: "existingdamagelandingpage", element: <DigitalVIRExistingdamagePage /> },
      { path: "incidentselection", element: <DigitalVIRIncidentSelection /> },
      { path: "vehicleconditionandpolice", element: <DigitalVIRVehicleConditionAndPolice /> },
      { path: "incidentdetails", element: <DigitalVIRIncidentDetails /> },
      { path: "otherdriverdetails", element: <DigitalVIROtherDriverDetails /> },
      { path: "thirdpartydetails", element: <DigitalVIRThirdPartyDetails /> },
      { path: "witnessdetails", element: <DigitalVIRWitnessDetails /> },
      { path: "damagedetails", element: <DigitalVIRDamageDetails /> },
      { path: "reviewpage", element: <DigitalVIRReviewPage /> },
      { path: "submissionpage", element: <DigitalVIRSubmissionPage /> },
      { path: "dive-finish", element: <DiveCompletePage /> },
      { path: "sms", element: <SmsPage /> },
      { path: "404", element: <NotFoundView /> },
      { path: "expire", element: <Expire /> },
      { path: "rentalexpired", element: <RentalExpiredPage /> },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
  {
    path: "rental",
    element: <RentalManageLayout />,
    children: [
      { path: "manage/login", element: <RentalManageLogin /> },
      { path: "manage/booking", element: <RentalManageBooking /> },
      { path: "manage/confirm", element: <RentalDateChangingComfirm /> },
      { path: "404", element: <NotFoundView /> },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: "generic-checkin/login", element: <GenericCheckinView /> },
      { path: "additional-driver-checkin/login", element: <CheckinView /> },
      { path: "additional-driver-checkin/steps", element: <CheckinSteps /> },
      { path: "additional-driver-checkin/privacy/*", element: <CheckinPrivacy /> },
      { path: "checkin/login", element: <CheckinView /> },
      { path: "checkin/steps", element: <CheckinSteps /> },
      { path: "checkin/privacy/*", element: <CheckinPrivacy /> },
      { path: "vehicleincidents/contact-us", element: <ContactUs /> },
      { path: "login", element: <LoginView /> },
      { path: "vehicleincidents/contact-us", element: <ContactUs /> },
      { path: "404", element: <NotFoundView /> },
      { path: "/", element: <DefaultView /> },
      { path: "*", element: <Navigate to="/404" /> },
      { path: "personalInfo", element: <PersonalInfoForm /> },
      enableDemo ? { path: "checkin-demo/login", element: <CheckinView /> } : {},
      enableDemo ? { path: "checkin-demo/steps", element: <CheckinSteps /> } : {},
      enableDemo ? { path: "checkin-demo/privacy/*", element: <CheckinPrivacy /> } : {},
    ],
  },

  enableDemo
    ? {
        path: "checkin-demo",
        element: <CheckinRoute component={CheckinLayout} />,
        children: [
          { path: "verify", element: <CheckinRoute component={CheckinVerify} /> },
          { path: "checkin-form", element: <CheckinRoute component={CheckinApp} /> },
          { path: "complete", element: <CheckinRoute component={CheckinComplete} /> },
          { path: "checkin-summary", element: <CheckinRoute component={CheckinSummary} /> },
          { path: "*", element: <Navigate to="/404" /> },
        ],
      }
    : {},
];

export default routes;
